import { createApi, fetchBaseQuery, retry } from "@reduxjs/toolkit/query/react";
import getBaseUrl from "../getBaseUrl";

const maxRetries = 0;

const dynamicBaseQuery = async (args: any, api: any, extraOptions: any) => {
  const rawBaseQuery = fetchBaseQuery({ baseUrl: getBaseUrl() });
  return rawBaseQuery(args, api, extraOptions);
};

const baseQuery = retry(dynamicBaseQuery, { maxRetries });

export const chartAPI = createApi({
  reducerPath: "chartAPI",
  baseQuery,
  keepUnusedDataFor: 0,
  tagTypes: [],
  refetchOnMountOrArgChange: true,
  refetchOnReconnect: true,
  endpoints: (builder) => ({
    //* *********************************************************** */
    //* GET FAULT CHARTS */
    postFaultChart: builder.mutation({
      query: (body: any) => ({
        url: "/reports/faults/chart",
        body: body.body,
        method: "post",
        headers: { authorization: body.token },
      }),
    }),
    //* *********************************************************** */
    //* GET TRAFFIC TRIPS AND FROM FLOOR CHART */
    postTrafficTripsToAndFromAFloor: builder.mutation({
      query: (body: any) => ({
        url: "/reports/traffic/chart/trips",
        body: body.body,
        method: "post",
        headers: { authorization: body.token },
      }),
    }),
    //* *********************************************************** */
    //* GET TRAFFIC HALL CALL CHART */
    postTrafficHallCall: builder.mutation({
      query: (body: any) => ({
        url: "/reports/traffic/chart/hall-button",
        body: body.body,
        method: "post",
        headers: { authorization: body.token },
      }),
    }),
    //* *********************************************************** */
    //* GET TRAFFIC DISTRIBUTION BY HOURLY INTERVAL */
    postTrafficDistribution: builder.mutation({
      query: (body: any) => ({
        url: "/reports/traffic/chart/distribution",
        body: body.body,
        method: "post",
        headers: { authorization: body.token },
      }),
    }),
    //* *********************************************************** */
    //* GET TRAFFIC WAIT TIME */
    postTrafficWaitTime: builder.mutation({
      query: (body: any) => ({
        url: "/reports/traffic/chart/wait-time",
        body: body.body,
        method: "post",
        headers: { authorization: body.token },
      }),
    }),
    //* *********************************************************** */
    //* GET CAR USE DAY  */
    postCarUseDay: builder.mutation({
      query: (body: any) => ({
        url: "/reports/usage/chart/day",
        body: body.body,
        method: "post",
        headers: { authorization: body.token },
      }),
    }),
    //* *********************************************************** */
    //* GET CAR USE COMPARISONS */
    postCarUseComparisons: builder.mutation({
      query: (body: any) => ({
        url: "/reports/usage/chart/comparison",
        body: body.body,
        method: "post",
        headers: { authorization: body.token },
      }),
    }),
    //* *********************************************************** */
    //* GET CAR USE DOOR TIMES */
    postCarUseTimes: builder.mutation({
      query: (body: any) => ({
        url: "/reports/usage/chart/door-times",
        body: body.body,
        method: "post",
        headers: { authorization: body.token },
      }),
    }),
    //* *********************************************************** */
    //* GET CAR SERVICE LOG */
    postCarServiceLog: builder.mutation({
      query: (body: any) => ({
        url: "/reports/service/chart/log",
        body: body.body,
        method: "post",
        headers: { authorization: body.token },
      }),
    }),
    //* *********************************************************** */
    //* GET GENERAL ELEVATOR AVAILABILITY */
    postGeneralElevatorAvailability: builder.mutation({
      query: (body: any) => ({
        url: "/reports/all-banks/out-of-service",
        body: body.body,
        method: "post",
        headers: { authorization: body.token },
      }),
    }),
    //* *********************************************************** */
  }),
});

export const {
  usePostFaultChartMutation,
  usePostTrafficTripsToAndFromAFloorMutation,
  usePostTrafficHallCallMutation,
  usePostTrafficDistributionMutation,
  usePostTrafficWaitTimeMutation,
  usePostCarUseDayMutation,
  usePostCarUseComparisonsMutation,
  usePostCarUseTimesMutation,
  usePostCarServiceLogMutation,
  usePostGeneralElevatorAvailabilityMutation,
} = chartAPI;
